import ConfirmModal from './ConfirmModal.container';

export default ConfirmModal;
